import { render, staticRenderFns } from "./BrAssessConfirmModal.vue?vue&type=template&id=5fda2a25&scoped=true"
import script from "./BrAssessConfirmModal.vue?vue&type=script&lang=js"
export * from "./BrAssessConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./BrAssessConfirmModal.vue?vue&type=style&index=0&id=5fda2a25&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fda2a25",
  null
  
)

export default component.exports